import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.75 2.25A.75.75 0 003 3v18c0 .414.336.75.75.75h10.5A.75.75 0 0015 21v-4.5a.75.75 0 00-1.5 0v3.75h-9V3.75h9V7.5a.75.75 0 001.5 0V3a.747.747 0 00-.75-.75H3.75zm17.03 9.198A.753.753 0 0121 12v.019a.757.757 0 01-.22.533l-3.712 3.727a.748.748 0 01-1.06 0 .755.755 0 010-1.065l2.431-2.442H9.753a.753.753 0 010-1.506h8.724l-2.47-2.48a.755.755 0 010-1.065.748.748 0 011.061 0l3.712 3.727z",
  clipRule: "evenodd"
})), "IconLogout");